import axios from "axios";
import {TTP_API_URL} from "Config";
import { updateSourceToken, throwCatchedError } from 'utils';

let fetchDocumentsSourceToken;
let fetchDocumentsAppRefsSourceToken;

export const fetchDocuments = ({token, params = {}, sourceToken=null}) => {
  fetchDocumentsSourceToken = updateSourceToken(fetchDocumentsSourceToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/billing/document`;
  const sort = params.sort ? params.sort : [{property: "createdAt", dir: "desc"}];
  const filter = params.filter ? params.filter : [];
  const start = params.start ? params.start : 0;
  const limit = params.limit ? params.limit : 10;

  return axios.get(requestUrl, {
    cancelToken: fetchDocumentsSourceToken.token,
    params: {
      access_token: token,
      fields: "*,user,issuer,moreDetailsUrl,toPostTreatment,clientState",
      filter: JSON.stringify(filter),
      sort: JSON.stringify(sort),
      start,
      limit
    }
  }).catch(function(thrown) {
    throwCatchedError(thrown)
  });
};

export const fetchDocumentsApp = (token) => {

  const requestUrl = `${TTP_API_URL}/billing/document/get-available-apps`;

  return axios.get(requestUrl, {
    params: {
      access_token: token
    }
  }).catch(function(thrown) {
    throwCatchedError(thrown)
  });
};

export const fetchDocument = (token, documentId) => {

  let filter = [];
  const requestUrl = TTP_API_URL+`/billing/document`;

  filter.push({
    property: 'id',
    value: documentId,
    operator: 'eq'
  });

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      fields : '*,user',
      filter: JSON.stringify(filter),
    }
  });
};


export const modifyDocument = (token, documentId, documentOrganization, documentStreet, documentPostalCode, documentUen, type, locality,adressLine2,clientReference) => {
  var documentType = type.replace("_", "-");
  const requestUrl = TTP_API_URL+`/billing/`+documentType.toLowerCase()+`/`+documentId;
  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('clientOrganization',documentOrganization);
  formData.append('clientStreet',documentStreet);
  formData.append('clientPostalCode',documentPostalCode);
  formData.append('clientUen',documentUen);
  formData.append('clientLocality',locality);
  if(adressLine2 !== null) {
    formData.append('adressLine2',adressLine2);
  }

  if(clientReference !== null) {
    formData.append('clientReference',clientReference);
  }
  return axios.post(requestUrl, formData);

};

export const cancelOrder = (token, orderId) => {
  const requestUrl = TTP_API_URL+`/billing/order/`+orderId;
  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('isCanceled', 1);
  return axios.post(requestUrl, formData);

};

export const modifyDocumentComment = (token, documentId, type, comment) => {
  var documentType = type.replace("_", "-");
  const requestUrl = TTP_API_URL+`/billing/`+documentType.toLowerCase()+`/`+documentId;
  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('comment',comment);
  return axios.post(requestUrl, formData);

};


export const regenerateAndSendDocument = (token, documentId, documentType, regenerate, sendEmail) => {
  const requestUrl = TTP_API_URL+`/billing/document/regenerate`;
  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('documentId',documentId);
  formData.append('documentType',documentType);
  formData.append('regenerate',regenerate);
  formData.append('sendEmail',sendEmail);
  return axios.post(requestUrl, formData);
};

export const getDocumentLinesForDocument = (token, documentId, documentType) => {

  if(documentType === "INVOICE") {

    return getDocumentLinesForInvoice(token, documentId);
  }
  const requestUrl = TTP_API_URL+`/billing/document_lines`;
  let filter = [];

  filter.push({
    property: 'documentType',
    value: documentType,
    operator: 'eq'
  });

  filter.push({
    property: 'documentId',
    value: documentId,
    operator: 'eq'
  });

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
    }
  });
};

export const getDocumentLinesForInvoice = (token, documentId) => {
  const requestUrl = TTP_API_URL+`/billing/invoice/get-document-lines`;
  return axios.get(requestUrl, {
    params: {
      access_token: token,
      id: documentId,
    }
  });
};

export const getPaymentForDocument = (token, documentId, documentType) => {
  const requestUrl = TTP_API_URL+`/billing/assignment`;
  let filter = [];

  filter.push({
    property: 'documentType',
    value: documentType,
    operator: 'eq'
  });

  filter.push({
    property: 'documentId',
    value: documentId,
    operator: 'eq'
  });

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      fields: "*,operation,document,assigner",
      filter: JSON.stringify(filter),
    }
  });
};


export const fetchDocumentsAppRef = (token, issuerId, year,appType, sourceToken=null) => {

  fetchDocumentsAppRefsSourceToken = updateSourceToken(fetchDocumentsAppRefsSourceToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/billing/document/get-available-app-ref`;

  return axios.get(requestUrl, {
    cancelToken: fetchDocumentsAppRefsSourceToken.token,
    params: {
      access_token: token,
      issuerId,
      year,
      appType
    }
  }).catch(function(thrown) {
    throwCatchedError(thrown)
  });
};

export const getDocumentStats = (token, dates, issuerId, app, appRef, search, status, orderStatus) => {

  const requestUrl = `${TTP_API_URL}/billing/document/sum-including-vat-amount-by-data`;
  return axios.get(requestUrl, {
    params: {
      access_token: token,
      dates,
      issuerId,
      app,
      appRef,
      search,
      status,
      orderStatus,

    }
  })
};

export const displayEfffDocumentFile = (token, documentId, documentType, officialNumber, documentUserId) => {

  const requestUrl = TTP_API_URL+`/billing/document/display-efff-document-file`;

  const fileName = documentType.toLowerCase()+'_'+officialNumber+'_'+documentUserId+'.efff'

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      documentId

    },
    responseType: 'blob'
  }).then((response) => {
    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    var fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);
    fileLink.click();
  });
};


export const fetchOrderByVcs = (token, vcs) => {

  let filter = [];
  const requestUrl = TTP_API_URL+`/billing/document`;

  filter.push({
    property: 'vcs',
    value: vcs,
    operator: 'eq'
  });


  return axios.get(requestUrl, {
    params: {
      access_token: token,
      fields : '*,user',
      filter: JSON.stringify(filter),
    }
  });
};

export const fetchCreditNotesByOrder = (token, orderId) => {

  let filter = [];
  const requestUrl = TTP_API_URL+`/billing/credit-note`;

  filter.push({
    property: 'order',
    value: orderId,
    operator: 'eq'
  });

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
    }
  });
};

export const changeOrdersRefundStatus = (token, orderIds) => {
  const requestUrl =TTP_API_URL+`/billing/document/multi-save-refund-by-bank-transfer-status`;
  let formData = new FormData();
  for (let i=0;i<orderIds.length;i++)
  {
    formData.append('documentIds['+i+']', orderIds[i]);
  }

  formData.append('access_token', token);

  return axios.post(requestUrl, formData);
};


export const createCreditNote = (token, invoiceId) => {

  const requestUrl =TTP_API_URL+`/billing/credit-note/create-credit-note`;
  var formData = new FormData();

  formData.append('access_token', token);
  formData.append('invoiceId', invoiceId);

  return axios.post(requestUrl, formData);
};


export const createPartialCreditNote = (token, invoiceId, description, vatRate, includingVatAmount, excludingVatAmount) => {

  const requestUrl =TTP_API_URL+`/billing/credit-note/create-partiel-credit-note`;
  var formData = new FormData();

  formData.append('access_token', token);
  formData.append('invoiceId', invoiceId);
  formData.append('description', description);
  formData.append('vatRate', vatRate);
  formData.append('includingVatAmount', includingVatAmount);
  formData.append('excludingVatAmount', excludingVatAmount);

  return axios.post(requestUrl, formData);
};

export const checkForMangopayPayment = (token, creditNoteId) => {

  const requestUrl = TTP_API_URL+`/billing/credit-note/check-mangopay-payment/`+creditNoteId;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
    }
  });
};

export const generateCreditNote = (token, invoiceId, cnLines, includingVatAmountTotal, excludingVatAmountTotal, comment, isCancellingRegistration) => {

  const requestUrl =TTP_API_URL+`/billing/credit-note/create-partiel-credit-note`;
  var formData = new FormData();

  formData.append('access_token', token);
  formData.append('invoiceId', invoiceId);
  /*for (let i=0;i<cnLines.length;i++)
  {
    formData.append('cnLines['+i+']', JSON.stringify(cnLines[i]));
  }*/
  formData.append('cnLines', JSON.stringify(cnLines));
  formData.append('includingVatAmountTotal', includingVatAmountTotal);
  formData.append('excludingVatAmountTotal', excludingVatAmountTotal);
  formData.append('comment', comment);
  formData.append('isCancellingRegistration', isCancellingRegistration);

  return axios.post(requestUrl, formData);
};

export const checkIfRegistrationIsCancelable = (token, invoiceId) => {

  const requestUrl = TTP_API_URL+`/billing/credit-note/check-registration-cancel-ability/`+invoiceId;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
    }
  });
};

let getCountDocumentsForFtpUploadToken;

export const getCountDocumentsForFtpUpload = (token, app, appRef, issuerId, year, discriminant, appType, sourceToken) => {

  getCountDocumentsForFtpUploadToken = updateSourceToken(getCountDocumentsForFtpUploadToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/billing/document/count-documents-for-ftp-upload`;

  return axios.get(requestUrl, {
    cancelToken: getCountDocumentsForFtpUploadToken.token,
    params: {
      access_token: token,
      app,
      appRef,
      issuerId,
      year,
      discriminant,
      appType,
    }
  })
};

export const startUploadDocumentsForFtpUploadCommand = (token, app, appRef, issuerId, year, discriminant, appType = []) => {

  const requestUrl = `${TTP_API_URL}/billing/document/upload-documents-to-ftp-server`;

  var formData = new FormData();

  formData.append('access_token', token);
  formData.append('issuerId', issuerId);
  formData.append('year', JSON.stringify(year));
  formData.append('discriminant', JSON.stringify(discriminant));

  return axios.post(requestUrl, formData);
};

export const getDocumentGuest = (token, guestId) => {
  const requestUrl = TTP_API_URL+`/event/guest/`+guestId;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
    }
  });
}

export const modifyReminderState = (token, documentId) => {

  const requestUrl = TTP_API_URL+`/billing/document/`+documentId;
  var formData = new FormData();

  formData.append('access_token', token);
  formData.append('reminderSent',0);

  return axios.post(requestUrl, formData);

};


export const validateVatNumber = (token,uen) => {

  const requestUrl = TTP_API_URL+`/billing/document/validate-uen`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      uen
    }
  });
};



// WEBPACK FOOTER //
// ./app/api/TamtamAPI/documents.js